import React from "react";
import Step1 from "../steps/section-5/step-1";
import Step2 from "../steps/section-5/step-2";
import Step3 from "../steps/section-5/step-3";
import Step4 from "../steps/section-5/step-4";

function TeamReportsSection5({
  step = 1,
  data = {},
  teams = {},
  costOfSales = 0,
  holdingCosts = 0,
  current_year = 0,
  incomeStatement,
  totalCosts = 0,
  avgMaterialCostsPerUnit = 0,
  avgLaborCostsPerUnit = 0,
  avgOverheadCostsPerUnit = 0
}) {
  if (step === 1) {
    return <Step1 />;
  }

  if (step === 2) {
    return <Step2 data={data} teams={teams} totalCosts={totalCosts} />;
  }

  if (step === 3) {
    return (
      <Step3
        avgMaterialCostsPerUnit={avgMaterialCostsPerUnit}
        avgLaborCostsPerUnit={avgLaborCostsPerUnit}
        avgOverheadCostsPerUnit={avgOverheadCostsPerUnit}
        data={data}
      />
    );
  }

  if (step === 4) {
    return (
      <Step4
        costOfSales={costOfSales}
        holdingCosts={holdingCosts}
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  return null;
}

export default TeamReportsSection5;



// WEBPACK FOOTER //
// ./src/components/team-reports/sections/section-5.js